import { fetchBaseQuery } from '@reduxjs/toolkit/query';
import { createApi } from '@reduxjs/toolkit/query/react';

const bookingsApis = createApi({
  reducerPath: 'bookingsApis',
  baseQuery: fetchBaseQuery({
    baseUrl: 'https://api.youcanbook.me/v1/',
    prepareHeaders: (headers) => {
      headers.set(
        'authorization',
        `Basic YXRwLmRyaXZlQGFjaGlldmUtdGVzdC1wcmVwLmNvbTpha19WdUo0SkJkY1ljNkxiSlpYU1ZOQVdzTFVIOXVWVE1HOGNONzIzbVB3elJhaE1RQkRCdw==`
      );
      return headers;
    },
  }),

  endpoints: (builder) => ({
    cancelYCBMBooking: builder.mutation<string, Record<string, unknown>>({
      query: ({ ID }) => ({
        url: `bookings/${ID}`,
        method: 'PATCH',
        body: {
          cancelled: true,
        },
      }),
    }),
  }),
});

// Export hooks for usage in function components, which are
// auto-generated based on the defined endpoints
export default bookingsApis;
export const { useCancelYCBMBookingMutation } = bookingsApis;
